import {ResponseData} from '@/services/types'
import http from '@/plugins/http-common'

class LeadService {
    getLeadById = (id: number): Promise<ResponseData> => http.get(`/leads/${id}`)
    changeLeadOwner = (leadId: number, agentId: number): Promise<ResponseData> => http.post(`/leads/${leadId}/change-owner`, {agent_id: agentId})
}

export default new LeadService()
